module.exports = __webpack_public_path__ + "img/tgch.6bffcec3.svg";